// Runtime configuration helper
// This allows environment variables to be set at runtime via docker-compose
// instead of being baked in at build time

export const getConfig = (key) => {
  // First check runtime config (set via config.js at container startup)
  if (window.__RUNTIME_CONFIG__ && window.__RUNTIME_CONFIG__[key]) {
    return window.__RUNTIME_CONFIG__[key];
  }
  // Fallback to build-time environment variables
  return process.env[key];
};

export const getBackendUrl = () => {
  return getConfig('REACT_APP_BACKEND_URL') || '';
};

export const getSiteTitle = () => {
  return getConfig('REACT_APP_SITE_TITLE') || getConfig('REACT_APP_TITLE') || 'Horeca Dashboard';
};

export const getCtaUrl = () => {
  return getConfig('REACT_APP_CTA_URL') || '';
};
